import React from 'react';

import styled from 'styled-components';
import { CBanner } from '@appcues/component-library';
import { ExternalLink, Link } from 'next/components/ui';
import GuideStep from 'components/InstallationGuide/GuideStep';
import GuideParagraph from 'components/InstallationGuide/GuideParagraph';
import GuideHeading from 'components/InstallationGuide/GuideHeading';
import { INSTALL_TEMPLATE_LINK } from 'constants/externalAppcuesResources';

export const InstallOverview = ({
  moveForward,
  moveBackward,
  stepMax,
  stepIndex,
}) => (
  <GuideStep
    stepIndex={stepIndex}
    title="Installing Appcues"
    stepMax={stepMax}
    customNextText="Start Developer Guide"
    moveForward={moveForward}
    moveBackward={moveBackward}
  >
    <GuideParagraph>
      Once you install Appcues, you can publish the content you build to your
      application. You can also target that content so it shows to just the
      right users at just the right time.
    </GuideParagraph>
    <GuideHeading>Not a developer?</GuideHeading>
    <GuideParagraph>
      If you&apos;re not comfortable inserting a bit of code into your
      application, you can <Link href="/settings/team">share</Link> this step by
      step guide with a developer.
    </GuideParagraph>
    <TemplateBox>
      <BoxParagraph className="box-paragraph">
        Make sure you let your developers know what user properties and events
        you need before they install Appcues. Filling out our template and
        sharing it with them is an easy way to do this.
      </BoxParagraph>
      <CBanner.Actions>
        <ExternalLink href={INSTALL_TEMPLATE_LINK}>Open Template</ExternalLink>
      </CBanner.Actions>
    </TemplateBox>
    <GuideHeading>A developer?</GuideHeading>
    <GuideParagraph isLastParagraph>
      You&apos;re in the right place! Click below to start the developer
      installation guide.
    </GuideParagraph>
  </GuideStep>
);

const TemplateBox = styled(CBanner)`
  width: 100%;
  max-width: 1200px;
`;

const BoxParagraph = styled.p`
  &.box-paragraph {
    margin-bottom: 0;
  }
`;

export default InstallOverview;
